let womenFootballeCompetitions: string | undefined;

function getWomenFootballCompetitions() {
    if (womenFootballeCompetitions !== undefined) {
        return womenFootballeCompetitions;
    }
    try {
        womenFootballeCompetitions =
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_catalog_women_football_freemium_popup',
                'competition_ids'
            );

        const womenFootballeCompetitionsArray: string[] = JSON.parse(
            womenFootballeCompetitions as string
        );

        return womenFootballeCompetitionsArray;
    } catch (e) {
        return [];
    }
}

export {getWomenFootballCompetitions};
